var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "side-nav-container" },
    [
      _c(
        "div",
        { staticClass: "off-canvas-nav-container" },
        [
          _c(
            "b-nav",
            {
              staticClass: "off-canvas-nav",
              class: { isAnimated: _vm.sidebarShowing },
              attrs: { vertical: "" },
              on: {
                mouseover: _vm.toggleOnCanvasNav,
                mouseout: _vm.toggleOffCanvasNav,
              },
            },
            [
              _c("b-nav-item", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchValue,
                      expression: "searchValue",
                    },
                  ],
                  staticClass: "search-input",
                  attrs: {
                    placeholder: _vm.$t("sidenav.search").toUpperCase(),
                  },
                  domProps: { value: _vm.searchValue },
                  on: {
                    focus: _vm.searchHasFocus,
                    blur: _vm.searchBlurred,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchValue = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _vm._l(_vm.filteredPageLinks, function (link) {
                return _c(
                  "localized-link",
                  {
                    key: link.name,
                    staticClass: "nav_menu_link",
                    attrs: { to: link.to, "active-class": "navItemActive" },
                    on: {
                      click: function ($event) {
                        return _vm.selectLink(link.name)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        on: {
                          mouseover: function ($event) {
                            return _vm.mouseOver(link.name)
                          },
                          mouseout: _vm.mouseOutOfHover,
                        },
                      },
                      [
                        _c(
                          "b-nav-item",
                          {
                            class: {
                              navItemHover: link.name === _vm.hoveredLink,
                            },
                            staticStyle: { "pointer-events": "none" },
                          },
                          [
                            _c("span", { staticClass: "nav-menu-link" }, [
                              _vm._v(_vm._s(_vm.$t(link.name).toUpperCase())),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-nav",
        {
          staticClass: "sidenavbar",
          attrs: { vertical: "" },
          on: {
            mouseover: _vm.toggleOnCanvasNav,
            mouseout: _vm.toggleOffCanvasNav,
            click: _vm.toggleSidebar,
          },
        },
        [
          _c("b-nav-item", [
            _c("i", { staticClass: "fi-magnifying-glass nav-icon" }),
          ]),
          _vm._v(" "),
          _vm._l(_vm.filteredPageLinks, function (link) {
            return _c(
              "localized-link",
              {
                key: link.name + "icon",
                class: { navIconHover: link.name == _vm.hoveredLink },
                attrs: { to: link.to, "active-class": "navItemActive" },
                on: {
                  click: function ($event) {
                    return _vm.selectLink(link.name)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "nav-item-icon",
                    on: {
                      mouseover: function ($event) {
                        return _vm.mouseOver(link.name)
                      },
                      mouseout: _vm.mouseOutOfHover,
                    },
                  },
                  [
                    _c("b-nav-item", { attrs: { "data-nav-id": "1" } }, [
                      _c("i", {
                        class: "fi-" + link.icon + " nav-icon",
                        staticStyle: { "pointer-events": "none" },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            )
          }),
          _vm._v(" "),
          (!!_vm.filteredContacts && _vm.filteredContacts.length > 0) ||
          (!!_vm.filteredBookings && _vm.filteredBookings.length > 0)
            ? _c("div", { staticClass: "search-results-list" }, [
                _c("div", { staticClass: "search-results-arrow-up" }),
                _vm._v(" "),
                _c("div", { staticClass: "search-results-list-box" }, [
                  _c(
                    "ul",
                    [
                      _vm.filteredBookings.length > 0
                        ? _c("li", { staticClass: "list-divider" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("sidenav.booking_results"))),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.filteredBookings, function (booking) {
                        return _c(
                          "li",
                          {
                            key: `booking-${booking.id}`,
                            on: {
                              click: function ($event) {
                                return _vm.handleBookingClicked(booking)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "search-preview-photo" },
                              [
                                _c("picture-placeholder", {
                                  attrs: {
                                    backgroundColor: "#FCFCFC",
                                    color: "#3A3B3D",
                                    fontSize: "20px",
                                    textIn: booking.name,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "search-results-card-title" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(booking.name) +
                                    "\n              "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "booking-date-span" },
                                  [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.formatDate(booking.starts_at)
                                        ) +
                                        " -\n                " +
                                        _vm._s(
                                          _vm.formatDate(booking.ends_at)
                                        ) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.filteredContacts.length > 0
                        ? _c("li", { staticClass: "list-divider" }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("sidenav.contact_results"))),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.filteredContacts, function (contact) {
                        return _c(
                          "li",
                          {
                            key: `contact-${contact.id}`,
                            on: {
                              click: function ($event) {
                                return _vm.handleContactClicked(contact)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "search-preview-photo" },
                              [
                                _c("picture-placeholder", {
                                  attrs: {
                                    pictureUrl:
                                      contact.photo_sm_uri || contact.photo_uri,
                                    backgroundColor: "#FCFCFC",
                                    color: "#3A3B3D",
                                    fontSize: "20px",
                                    textIn:
                                      contact.first_name.toUpperCase() +
                                      " " +
                                      contact.last_name.toUpperCase(),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "search-results-card-title" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(contact.first_name) +
                                    " " +
                                    _vm._s(contact.last_name) +
                                    "\n              " +
                                    _vm._s(
                                      contact.email
                                        ? `(${contact.email})`
                                        : null
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "contact-modal",
        { ref: "contactModal" },
        [
          _c(
            "template",
            { slot: "submit" },
            [
              _c("b-button", { on: { click: _vm.handleUpdateContact } }, [
                _vm._v("Update"),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "booking-modal",
        { ref: "bookingModal" },
        [_c("template", { slot: "submit" })],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }